import { render, staticRenderFns } from "./UnsubDetail.vue?vue&type=template&id=e39aa350&scoped=true&"
import script from "./UnsubDetail.vue?vue&type=script&lang=js&"
export * from "./UnsubDetail.vue?vue&type=script&lang=js&"
import style0 from "./UnsubDetail.vue?vue&type=style&index=0&id=e39aa350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39aa350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
